/**
 * SleepyCat cart analytics — view_cart / remove_from_cart (GA4-clean).
 *
 * Why this exists: the theme's add-to-cart pushes are surface-specific and unit-inconsistent;
 * these two cart events were missing entirely. This helper builds a clean GA4 ecommerce object
 * (rupees, item_variant, value = line/cart total) and pushes via SCAnalytics so the events
 * inherit the schema_version envelope + the { ecommerce: null } reset. One source of truth,
 * called from the cart drawer, the cart page, and the remove button.
 *
 * Scope: pre-checkout only. begin_checkout / purchase are owned by Razorpay (not fired here).
 *
 * @version 1.0.0
 */
(function () {
  'use strict';
  if (window.Shopify && window.Shopify.designMode) return;
  if (window.SCCart) return;

  var MONEY = 100; // Shopify AJAX money is in cents

  function unitPrice(it) {
    var cents = (it.final_price != null) ? it.final_price : it.price;
    return +(cents / MONEY).toFixed(2);
  }

  // Map Shopify cart line items -> GA4 items[] (rupees, standard keys only).
  function toItems(lineItems) {
    return (lineItems || []).map(function (it, i) {
      // item_id is the Shopify PRODUCT id on every surface, so GA4 can join
      // view_item -> add_to_cart -> view_cart -> purchase on a single key. SKU and
      // variant id travel alongside as item-scoped dimensions rather than competing
      // for item_id (which previously made this the only SKU-keyed surface).
      var item = {
        item_id: String(it.product_id),
        item_name: it.product_title || it.title,
        price: unitPrice(it),
        quantity: it.quantity,
        index: i
      };
      if (it.sku) item.item_sku = it.sku;
      if (it.variant_id) item.item_variant_id = String(it.variant_id);
      if (it.vendor) item.item_brand = it.vendor;
      if (it.product_type) item.item_category = it.product_type;
      if (it.variant_title) item.item_variant = it.variant_title;
      return item;
    });
  }

  function emit(event, ecommerce) {
    if (window.SCAnalytics && window.SCAnalytics.push) {
      // SCAnalytics resets { ecommerce: null } for ecom events + adds schema_version.
      window.SCAnalytics.push(event, { ecommerce: ecommerce });
    } else {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ ecommerce: null });
      window.dataLayer.push({ event: event, schema_version: 'v2', ecommerce: ecommerce });
    }
  }

  function getCart() {
    var base = (window.routes && window.routes.cart_url) ? window.routes.cart_url : '/cart';
    return fetch(base + '.js', { headers: { Accept: 'application/json' } }).then(function (r) {
      return r.json();
    });
  }

  var inFlightView = false;

  var SCCart = {
    // Fire view_cart with the full cart. Guarded against concurrent double-calls.
    viewCart: function () {
      if (inFlightView) return;
      inFlightView = true;
      getCart().then(function (cart) {
        if (cart && cart.item_count) {
          emit('view_cart', {
            currency: cart.currency,
            value: +(cart.total_price / MONEY).toFixed(2),
            items: toItems(cart.items)
          });
        }
      }).catch(function () {}).finally(function () { inFlightView = false; });
    },

    // index = 1-based Shopify line index (the data-index on <cart-remove-button>).
    // Read at click time, before the line is removed.
    removeFromCart: function (index) {
      var i = parseInt(index, 10);
      if (!i) return;
      getCart().then(function (cart) {
        if (!cart || !cart.items || !cart.items[i - 1]) return;
        var it = cart.items[i - 1];
        emit('remove_from_cart', {
          currency: cart.currency,
          value: +((unitPrice(it) * it.quantity)).toFixed(2),
          items: toItems([it])
        });
      }).catch(function () {});
    }
  };

  window.SCCart = SCCart;
})();
